import { useTheme, Box, Typography } from '@mui/material';

import { colorTheme } from 'theme';

import { strings } from 'i18n/Strings';

import { CustomDataGrid, DialogBox } from 'components';
import { type GridColumns, type GridValidRowModel } from '@mui/x-data-grid';
import { commonConstantTexts } from 'constants/constantText';

interface IUploadFile {
  errData: never[];
  isModalOpen: boolean;
  handleCreateDialogClose: () => void;
}

const UploadFileError = (props: IUploadFile): JSX.Element => {
  type GridRowData = Record<string, unknown>;
  const currentTheme = useTheme();
  const colors = colorTheme(currentTheme.palette.mode);

  const columns: GridColumns<GridValidRowModel> = [
    'First Name*',
    'Last Name*',
    'Email*',
    'Mobile prefix*',
    'Mobile number*',
    'Employee ID',
    'Job Title',
    'Department',
    'Location',
    'Start Date (DD-MM-YYYY)',
    'Gender*',
    'Are you, or have you been within the last 12 months, a Politically Exposed Person (PEP) or Relative of Close Associate (RCA) of a PEP?*',
    'Marital Status*',
    'Economic Status*',
    'Economic Occupation*',
    'Employee Contribution*',
    'Employer Contribution*',
    'Error',
  ].map((field) => ({
    field,
    width: field === 'Error' ? 600 : 200, // Adjust width as needed
    renderHeader: () => (
      <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
        {field}
      </Typography>
    ),
    renderCell: ({ row }) => (
      <Typography
        variant="h5"
        color={field === 'Error' ? colors.primaryRed[100] : colors.gray[100]}
        fontSize={14}
        sx={{ whiteSpace: 'pre-wrap' }}
      >
        {row[field] || ''}
      </Typography>
    ),
  }));

  return (
    <DialogBox
      open={props.isModalOpen}
      onClose={props.handleCreateDialogClose}
      title={strings.displayText.uploadEmployee}
      className={''}
      fullWidth={true}
      screenWidth="xl"
    >
      <Box>
        <CustomDataGrid
          currentPage={strings.displayText.uploadEmployee}
          columns={columns}
          rows={props.errData}
          getRowId={(row: GridRowData) =>
            // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
            `${String(row['Email*'])}_${row.error}_${row['Mobile number*']}_${
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              row['First Name*']
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            }_${row['Last Name*']}`
          }
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? commonConstantTexts.evenText
              : commonConstantTexts.oddText
          }
          pageCount={props.errData.length}
        />
      </Box>
    </DialogBox>
  );
};
export default UploadFileError;
